module.exports = __webpack_public_path__ + "static/media/shop.4071964f.png";